import { Switch } from "react-router-dom";
import Route from "../Route";

import FaturamentoContrato from "../../pages/faturamento/contrato/FaturamentoContrato";
import { FaturamentoContratoContextProvider } from "../../pages/faturamento/contrato/contexts/FaturamentoContratoContext";
import TipoServicoCadastro from "../../pages/faturamento/tiposervico/TipoServicoCadastro";
import TipoServicoListagem from "../../pages/faturamento/tiposervico/TipoServicoListagem";
import { TipoServicoContextProvider } from "../../pages/faturamento/tiposervico/contexts/TipoServicoContext";

import ClassificacaoServicoCadastro from "../../pages/faturamento/classificacaoservico/ClassificacaoServicoCadastro";
import ClassificacaoServicoListagem from "../../pages/faturamento/classificacaoservico/ClassificacaoServicoListagem";
import { ClassificacaoServicoProvider } from "../../pages/faturamento/classificacaoservico/contexts/ClassificacaoServicoContext";
import ContractsCadastro from "../../pages/faturamento/contratomodelo/ContractsCadastro";
import ContractsList from "../../pages/faturamento/contratomodelo/ContractsList";
import DespesasReembolsaveisCadastro from "../../pages/faturamento/despesasreembolsaveis/DespesasReembolsaveisCadastro";
import DespesasReembolsaveisListagem from "../../pages/faturamento/despesasreembolsaveis/DespesasReembolsaveisListagem";
import EspelhoFaturamento from "../../pages/faturamento/espelhoFaturamento";
import GerenciamentoContratoCadastro from "../../pages/faturamento/gerenciamentocontrato/GerenciamentoContratoCadastro";
import GerenciamentoContratoListagem from "../../pages/faturamento/gerenciamentocontrato/GerenciamentoContratoListagem";
import MotivoCancelamentoCadastro from "../../pages/faturamento/motivocancelamento/MotivoCancelamentoCadastro";
import MotivoCancelamentoListagem from "../../pages/faturamento/motivocancelamento/MotivoCancelamentoListagem";
import { MotivoCancelamentoProvider } from "../../pages/faturamento/motivocancelamento/context/MotivoCancelamentoContext";
import NotasServico from "../../pages/faturamento/notafiscalservico";
import { ReguaCobranca } from "../../pages/faturamento/reguaCobranca/ReguaCobranca";
import RevisaoContrato from "../../pages/faturamento/revisaocontrato/RevisaoContrato";
import { TriagemContrato } from "../../pages/faturamento/triagemContrato/TriagemContrato";
import { GerenciamentoContratoFilterContextProvider } from "../../pages/faturamento/gerenciamentocontrato/contexts/GerenciamentoContratoFilterContext";
import { ConfigurationContextProvider } from "../../pages/faturamento/gerenciamentocontrato/contexts/ConfigurationContext";

export default function Faturamento() {
  return (
    <>
      <FaturamentoContratoContextProvider>
        <Switch>
          <Route
            path="/faturamento/gerenciamentocontrato/faturamento"
            component={FaturamentoContrato}
          />
        </Switch>
      </FaturamentoContratoContextProvider>

      <TipoServicoContextProvider>
        <Switch>
          <Route
            path="/faturamento/tiposervico/listagem"
            component={TipoServicoListagem}
          />
          <Route
            path="/faturamento/tiposervico/cadastro"
            component={TipoServicoCadastro}
          />
        </Switch>
      </TipoServicoContextProvider>

      <ConfigurationContextProvider>
        <ClassificacaoServicoProvider>
          <Switch>
            <Route
              path="/faturamento/classificacaoservico/listagem"
              component={ClassificacaoServicoListagem}
            />
            <Route
              path="/faturamento/classificacaoservico/cadastro"
              component={ClassificacaoServicoCadastro}
            />
          </Switch>
        </ClassificacaoServicoProvider>
      </ConfigurationContextProvider>

      <MotivoCancelamentoProvider>
        <Switch>
          <Route
            path="/faturamento/motivocancelamento/listagem"
            component={MotivoCancelamentoListagem}
          />
          <Route
            path="/faturamento/motivocancelamento/cadastro"
            component={MotivoCancelamentoCadastro}
          />
        </Switch>
      </MotivoCancelamentoProvider>

      <Switch>
        <Route
          path="/faturamento/contrato/revisao"
          component={RevisaoContrato}
        />

        <Route
          path="/faturamento/triagemcontrato/listagem"
          component={TriagemContrato}
        />

        <Route path="/faturamento/reguacobranca" component={ReguaCobranca} />

        <Route
          path="/faturamento/despesasreembolsaveis/listagem"
          component={DespesasReembolsaveisListagem}
        />

        <Route
          path="/faturamento/despesasreembolsaveis/cadastro"
          component={DespesasReembolsaveisCadastro}
        />
      </Switch>
      <ConfigurationContextProvider>
        <GerenciamentoContratoFilterContextProvider>
          <Switch>
            <Route
              path="/faturamento/gerenciamentocontrato/cadastro"
              component={GerenciamentoContratoCadastro}
            />

            <Route
              path="/faturamento/gerenciamentocontrato/listagem"
              component={GerenciamentoContratoListagem}
            />
          </Switch>
        </GerenciamentoContratoFilterContextProvider>
      </ConfigurationContextProvider>

      <Switch>
        <Route path="/faturamento/nota" component={NotasServico} />
        <Route path="/faturamento/espelho" component={EspelhoFaturamento} />
      </Switch>

      <Switch>
        <Route
          path="/faturamento/contratomodelo/cadastro"
          component={ContractsCadastro}
        />
        <Route
          path="/faturamento/contratomodelo/listagem"
          component={ContractsList}
        />
      </Switch>
    </>
  );
}
